import { call, put, select } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { assignTeamZips, getAreaTeams, selectArea } from '../../redux';
function* handleAssignTeamZips({ payload }) {
    const { teamId, callback, zips } = payload;
    try {
        const response = (yield call(Api.assignTeamZips, teamId, { zips }));
        yield put(assignTeamZips.success(response.data));
        const { area } = (yield select(selectArea));
        if (area?.id) {
            // TODO: Add ability to reload only team statistics, e.g. add payload parameter to `getAreaTeams.request`
            yield put(getAreaTeams.request({ areaId: area.id }));
        }
        yield call(callback);
    }
    catch (error) {
        yield put(assignTeamZips.failure(error));
    }
}
export default handleAssignTeamZips;
